const FEATURES = [
  {
    id: 'fe1',
    icon: 'ri-radar-line',
    title: '全天候热点监控',
    desc: '7×24 小时实时追踪各大平台热搜事件，确保你不会错过任何一个网络热门事件。',
  },
  {
    id: 'fe2',
    icon: 'ri-time-line',
    title: '完整时间线梳理',
    desc: '为每个网络大事件梳理完整发展脉络，从引爆点到最新进展一目了然。',
  },
  {
    id: 'fe3',
    icon: 'ri-stack-line',
    title: '吃瓜事件汇总',
    desc: '按主题分类整理热门爆料与吃瓜事件，方便你快速浏览感兴趣的内容类型。',
  },
  {
    id: 'fe4',
    icon: 'ri-shield-check-line',
    title: '多信源交叉验证',
    desc: '严格的内容审核机制，对每一条最新网络热点进行多来源核实，拒绝虚假爆料。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          为什么吃瓜群众都在用五一吃瓜网
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FEATURES.map((f) => (
            <div
              key={f.id}
              className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center"
            >
              <div className="w-14 h-14 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${f.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}